document.querySelectorAll('[data-header]').forEach((header) => {
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      if (window.scrollY > 50) {
        header.classList.add('shadow-sm');
        header.classList.replace('bg-surface/80', 'bg-surface/95');
      } else {
        header.classList.remove('shadow-sm');
        header.classList.replace('bg-surface/95', 'bg-surface/80');
      }
      ticking = false;
    });
  }, { passive: true });

  const toggle = header.querySelector('[data-mobile-menu-toggle]');
  const menu = header.querySelector('[data-mobile-menu]');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('hidden') === false;
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }

  const searchToggle = header.querySelector('[data-search-toggle]');
  const searchPanel = header.querySelector('[data-search-panel]');
  const searchClose = header.querySelector('[data-search-close]');
  const searchInput = header.querySelector('[data-search-input]');

  if (searchToggle && searchPanel) {
    const openSearch = () => {
      searchPanel.classList.remove('hidden');
      searchToggle.setAttribute('aria-expanded', 'true');
      searchInput?.focus();
    };

    const closeSearch = () => {
      searchPanel.classList.add('hidden');
      searchToggle.setAttribute('aria-expanded', 'false');
    };

    searchToggle.addEventListener('click', () => {
      if (searchPanel.classList.contains('hidden')) {
        openSearch();
      } else {
        closeSearch();
      }
    });

    searchClose?.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !searchPanel.classList.contains('hidden')) {
        closeSearch();
      }
    });
  }
});
